import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader, HideOnPrint, TaskFeedback } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import fetch from 'features/common/fetch';
import { getDetail } from 'features/views/taskDetail/selectors';

const { urls } = fetch.constants;

export const Feedback = ({ onReload }) => {
	const task = useSelector(getDetail);

	const ignoreErrorsForTaskDetailUserHasNoAccess = useIgnoreErrorsWhen({
		fetchStorePath: urls.taskDetail,
		attributePath: ['metaData', 'parsedContent', 'status'],
		value: 403,
	});

	return (
		<HideOnPrint>
			<ComponentLoader
				fetchStorePath={urls.taskDetail}
				onReload={onReload}
				ignoreErrors={ignoreErrorsForTaskDetailUserHasNoAccess}
			>
				<Stack spacing={2}>
					<Stack spacing={1} sx={{ mb: 2 }}>
						<SectionHeader text={getLabelMessage('detail:feedBackSubheader')} />
						<Alert sx={{ mb: 1 }} severity="info">
							{getLabelMessage('detail:feedbackInfo')}
						</Alert>
					</Stack>

					<TaskFeedback task={task} />
				</Stack>
			</ComponentLoader>
		</HideOnPrint>
	);
};

Feedback.propTypes = {
	onReload: PropTypes.func,
};

export default Feedback;
